module.exports = __webpack_public_path__ + "assets/img/27-m.fccb31c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/27-m.jpg
// module id = wP7n
// module chunks = 0